import {RouteRecordRaw} from "vue-router";

export default <Array<RouteRecordRaw>>[
    {
        path: '/login',
        name: 'login',
        meta: {auth: false},
        components: {
            default: () => import(/* webpackChunkName: "login" */ './LoginPage.vue'),
        },
    }
]
